import Vue from "vue";
import Vuex from "vuex";
import { IState } from "@/interfaces/IState";
import { toast } from "@/store/toast";
import {poll} from "@/store/poll";
import VuexPersistence from 'vuex-persist'
import { pdf } from '@/store/pdf';
import { user } from "@/store/user";

Vue.use(Vuex);

export default new Vuex.Store<IState>({
  modules: {
    toast: toast,
    poll: poll,
    pdf: pdf,
    user:user
  },
  plugins: [new VuexPersistence().plugin]
});

